function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import PropTypes from 'prop-types';
import { hoistStatics, pure } from 'recompose';
import { hashObject } from "../../utils/util";
/* withHashId higher-order component
 *
 * Auto-generates ids to be used for accessibility
 * e.g. <label for="someId"> and <input id="someId"> elements
 *
 * Usages:
 *  const ComponentWithwithHashId = withHashId()(Component)
 *  const ComponentWithwithHashId = withHashId(propToPassHashId)(Component)
 */

var withHashId = function withHashId() {
  var propForHashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'componentId';
  return function (WrappedComponent) {
    var componentName = WrappedComponent.displayName || WrappedComponent.name;

    var HOC =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(HOC, _React$Component);

      function HOC(props) {
        var _this;

        _classCallCheck(this, HOC);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(HOC).call(this, props));
        _this._hashId = hashObject(props);
        return _this;
      }

      _createClass(HOC, [{
        key: "render",
        value: function render() {
          var props = _objectSpread({}, this.props, _defineProperty({}, propForHashId, "".concat(componentName, "_").concat(this._hashId)));

          return React.createElement(WrappedComponent, props);
        }
      }]);

      return HOC;
    }(React.Component);

    _defineProperty(HOC, "displayName", "withHashId(".concat(componentName, ")"));

    hoistStatics(WrappedComponent, HOC);
    return pure(HOC);
  };
};

export default withHashId;